import React from "react";
import Modal from "../../CommonComponents/common/modal/Modal";
import DataTable from "../../CommonComponents/common/datatable/DataTable";
import { Box } from "@mui/material";

export const InventoryViewModal = ({
  open,
  handleClose,
  rows = [],
  columns = [],
  title
}) => {
  return (
    <Modal
      open={ open }
      handleClose={ handleClose }
      title={ title }
      maxWidth="sm"
      fullWidth={ true }
      content={
        <Box sx={ { width: "850px", textOverflow: "clip" } }>
          <DataTable
            columns={ columns }
            rows={ rows }
            autoHeight={ true }
            rowHeight={ 40 }
            headerHeight={ 35 }
            hideCheckbox
            loading={ rows.length === 0 }
          />
        </Box>
      }
      action={
        <Box display="flex" justifyContent="flex-end" width="100%">
          <button className="btn btn-primary" onClick={ handleClose }>
            Close
          </button>
        </Box>
      }
    />
  );
};
